const e=(e,t)=>(e=Object.assign({},e),Object.entries(e).forEach((([s,a])=>t(a)&&delete e[s])),e);export{e as default};
